module.exports = __webpack_public_path__ + "static/media/valis.d6404e33.png";


/*****************
 ** WEBPACK FOOTER
 ** ./src/img/valis.png
 ** module id = 295
 ** module chunks = 0
 **/